export default __webpack_public_path__ + "static/media/logo-small-new-login.2d15dc87.svg";